module.exports = __webpack_public_path__ + "static/media/4_diagram_2.ae44f03d.svg";